module.exports = __webpack_public_path__ + "aa81bb9ef6d3ed6a6d20b6468ee40d02.svg";